import { CallEventType } from '../../ng-services/chat-call-notifier.service';

(function () {
    class ChatCallEventComponent {
        type!: CallEventType;

        get isSuccess() {
            return this.type === 'answered';
        }

        get isRejected() {
            return this.type === 'rejected';
        }

        get isMissed() {
            return this.type === 'unanswered';
        }

        get isCanceled() {
            return this.type === 'canceled';
        }
    }

    angular.module('tradersyard').component('tyChatCallEvent', {
        // language=HTML
        template: `
        <div class="chat_call_event" ng-class="{'is-success': $ctrl.isSuccess}">
            <i class="fa fa-phone chat_call_event__icon"></i>
            <span ng-if="$ctrl.isSuccess">Video call</span>
            <span ng-if="$ctrl.isRejected">Video call rejected</span>
            <span ng-if="$ctrl.isMissed">Missed video call</span>
            <span ng-if="$ctrl.isCanceled">Video call canceled</span>
        </div>
`,
        bindings: {
            type: '<',
        },
        controller: ChatCallEventComponent,
    });
})();
